import { ChevronIcon } from '@payloadcms/ui';

interface WizardStepHeaderProps {
  title: string;
  onBack: () => void;
  backDisabled?: boolean;
}

export const WizardStepHeader = ({ title, onBack, backDisabled }: WizardStepHeaderProps) => {
  return (
    <div className="fv-create-new-landing-modal__step-header">
      <button
        type="button"
        className="fv-create-new-landing-modal__back"
        onClick={onBack}
        disabled={backDisabled}
        aria-label="Go back to previous step"
        data-testid="create-new-landing-step-back"
      >
        <ChevronIcon direction="left" size="small" />
      </button>
      <h2>{title}</h2>
    </div>
  );
};
